import { render, staticRenderFns } from "./ContractInfoTab.vue?vue&type=template&id=3c61622e&scoped=true"
import script from "./ContractInfoTab.vue?vue&type=script&lang=js"
export * from "./ContractInfoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c61622e",
  null
  
)

export default component.exports